import moment from 'moment'

export const getNumberOfDays = (year, month) => {
    return 40 - new Date(year, month, 40).getDate()
}

const isPresent = (val) => {
    return val !== null && val !== undefined
}

export const isValidDate = (d: any) => {
    if (d === undefined || d === null) {
        return false
    }
    const date = moment(d)
    return date.isValid()
}

export const getToday = () => {
    const d = new Date()
    const today = new Date(d.getFullYear(), d.getMonth(), d.getDate())
    today.setHours(0, 0, 0, 0)
    return today
}

export const datesAreSame = (date1, date2) => {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    )
}

export const dateHelper = {
    yesterday: {
        name: 'Yesterday',
        onSelect: (setStartDate, setEndDate) => (e) => {
            const today = getToday()
            const yesterday = new Date(today)
            yesterday.setDate(yesterday.getDate() - 1)
            setStartDate(yesterday)
            setEndDate(yesterday)
        },
    },
}

export const constructDate = (day, month, year) => {
    if (isPresent(day) && isPresent(month) && isPresent(year)) {
        const _day = parseInt(day)
        const _month = parseInt(month)
        const _year = convertYear(parseInt(year))
        return moment([_year, _month, _day]).toDate()
    }
    return null
}
export const convertYear = (year) => {
    if (year < 99) {
        return year + 2000
    }
    return year
}

//Make sure the helper key is added to the defined helper types in DateRangePicker.types.ts
export const predefinedDateHelpers = {
    pastMonth: {
        name: 'Past 30 Days',
        setDate: function () {
            const end = new Date()
            const start = moment().subtract(30, 'days').toDate()
            return { start, end }
        },
    },
    pastYear: {
        name: 'Past 365 Days',
        setDate: function () {
            const end = new Date()
            const start = moment().subtract(365, 'days').toDate()
            return { start, end }
        },
    },
    pastWeek: {
        name: 'Past 7 Days',
        setDate: function () {
            const end = new Date()
            const start = moment().subtract(7, 'days').toDate()
            return { start, end }
        },
    },
    sinceYearStart: {
        name: 'Since Start of Year',
        setDate: function () {
            const end = new Date()
            const start = new Date(end.getFullYear(), 0, 1)
            return { start, end }
        },
    },
}
